import {HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import * as XLSX from "xlsx";
import {DecimalPipe} from "@angular/common";

function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
        errorMessage = `An error occurred: ${err.error.message}`;
    } else {
        errorMessage = `Server returned code: ${err.status}, error message is: ${err.message
        }`;
    }
    console.error(errorMessage);
    return throwError(() => errorMessage);
}

export function exportToCSV(data: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const csvData: string = XLSX.utils.sheet_to_csv(worksheet);
    const blob: Blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    const currentDate = new Date().toISOString().split('T')[0];
    link.download = `${fileName}_${currentDate}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function exportToExcel(data: any[][], fileName: string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Plan Cards');
    const currentDate = new Date().toISOString().split('T')[0];
    const fullFileName = `${fileName}_${currentDate}.xlsx`;
    XLSX.writeFile(workbook, fullFileName);
}


export function formatNumber(value: number, decimalPoints: number = 2): string {
    const factor = Math.pow(10, decimalPoints);
    const truncatedValue = Math.floor(value * factor) / factor;
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimalPoints,
        maximumFractionDigits: decimalPoints
    }).format(truncatedValue);
}

export function downloadXml(jsonData: any): void {
    const jsonToXml = (obj: any): string =>
        Object.entries(obj).map(([key, val]) =>
            Array.isArray(val) ? val.map(item => `<${key}>${typeof item === 'object' ? jsonToXml(item) : item}</${key}>`).join('')
                : typeof val === 'object' ? `<${key}>${jsonToXml(val)}</${key}>`
                    : `<${key}>${val}</${key}>`
        ).join('');
    const xmlString = `<?xml version="1.0" encoding="UTF-8"?><root>${jsonToXml(jsonData)}</root>`;
    let packingSlipNumber = jsonData?.SdDataSlice?.SdPackingSlip?.PackingSlipNumber || 'PL';
    packingSlipNumber = packingSlipNumber.replace(/^IMD/, '');
    const a = Object.assign(document.createElement('a'), {
        href: URL.createObjectURL(new Blob([xmlString], {type: 'application/xml'})),
        download: `${packingSlipNumber}.xml`
    });
    document.body.appendChild(a).click();
    document.body.removeChild(a);
}


const decimalPipe = new DecimalPipe('en-US');

export function numberFormat(value: number | string, format: string = '1.0-0'): string {
    return decimalPipe.transform(value, format) || '';
}

export function capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}


export function roundUp(num: number, decimals: number): number {
    const factor = Math.pow(10, decimals);
    return Math.ceil(num * factor) / factor;
}

export function getFileNameFromResponse(response: any): string | null {
    console.log(response)
    const contentDisposition = response.headers.get('Content-Disposition');
    console.log(contentDisposition)
    if (contentDisposition) {
        const matches = /filename="([^"]+)"/.exec(contentDisposition);
        console.log(matches)
        return matches?.[1] ?? null;
    }
    return null;
}

export function openOrDownloadFile(blob: any, fileName: string, fileExtension = 'pdf'): void {
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    const fullFileName = `${fileName}_${timestamp}.${fileExtension}`;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fullFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

export function excelDateToJSDate(value: any): string {
    if (!value) return '';

    if (typeof value === 'number') {
        const utc_days = Math.floor(value - 25569);
        const utc_value = utc_days * 86400;
        const date = new Date(utc_value * 1000);
        return date.toISOString().split("T")[0];
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? '' : date.toISOString().split("T")[0];

}